import { polymorphicFactory, Box, Spacer, Grid, GridColumn, Typography, DsmColor, omitText, Carousel, CarouselSlide } from '@kohler-dsm-library/kohler-core';
import { clsx } from 'clsx';
import React from 'react';
import { VideoCard } from './subcomponents/VideoCard/VideoCard.mjs';
import classes from './VideoSlider.module.css.mjs';

const VideoSlider = polymorphicFactory(
  (props, ref) => {
    const { component = "section", mod = "white", heading, cards, topSpacer, bottomSpacer, className, ...rest } = props;
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        className: clsx("kohler-video-slider-root", classes.videoSliderContainer, className),
        ref,
        mod,
        ...rest
      },
      topSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...topSpacer }),
      /* @__PURE__ */ React.createElement(Grid, { className: classes.videoSliderGrid }, heading && /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(classes.videoSliderContentContainer) }, /* @__PURE__ */ React.createElement(Typography, { component: heading.component || "h2", ...omitText(heading), size: "h2", textColor: DsmColor.ContentSecondary }, heading.text)), cards?.length && /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(classes.videoCarouselSliderGrid) }, /* @__PURE__ */ React.createElement(
        Carousel,
        {
          withControls: true,
          includeGapInSize: false,
          slideSize: 0,
          slideGap: "5px",
          align: "start",
          loop: false,
          containScroll: "trimSnaps",
          hideControlOnDisabled: false,
          carouselControlProps: {
            isOnPhoto: false,
            variant: "slider"
          }
        },
        cards.map((card) => /* @__PURE__ */ React.createElement(CarouselSlide, { key: card.heading.text }, /* @__PURE__ */ React.createElement(VideoCard, { ...card })))
      ))),
      bottomSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...bottomSpacer })
    );
  }
);

export { VideoSlider };
